import { useCallback } from 'react';

import { useConfig } from '../../../../context';
import { mapRoutePath } from './mapRoutePath';

type RoutePath = {
	(path: string): string;
	(paths: string[]): string[];
};

export function useRoutePath(): RoutePath {
	const enabled = useConfig().global.alternativeRouting ?? false;

	return useCallback(
		((path: string | string[]) => mapRoutePath(path as string, enabled)) as RoutePath,
		[enabled]
	);
}
